module.exports = __webpack_public_path__ + "static/qh_4.d798e23d.jpg";